import React, { useContext, useEffect, useState } from "react";
import suss from "../../assets/images/SuccessAge.svg";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import ApiConfig from "../../api/ApiConfig";
import { simplePostCall } from "../../api/ApiServices";

const Success = () => {


  const { LinkproductId, ageTokan, setAgeTokan,LinkOrderId,  } =
  useContext(AppContext);
  console.log("link testing",LinkOrderId);


  const [itemsmachineId, setItemsmachineId] = useState([]);
  const [itemsproductID, setItemsproductID] = useState([]);
  const [itemsLinkslotno, setItemsLinkslotno] = useState([]);
  const [itemsLinkOrderId, setItemsLinkOrderId] = useState([]);
  const [itemsLUserID, setItemsUserID] = useState([]);



  useEffect(() => {
    const items1 = JSON.parse(localStorage.getItem('vendingmachineidLinkID'));
    const [key1, value1] = items1?.split('=');
   
    const items2 = JSON.parse(localStorage.getItem('productLinkID'));
    const [key2, value2] = items2?.split('=');

    const items3 = JSON.parse(localStorage.getItem('slotnoLinkID'));
    const [key3, value3] = items3?.split('=');

    const items4 = JSON.parse(localStorage.getItem('OrderLinkID'));
    const [key4, value4] = items4?.split('=');

    const items5 = JSON.parse(localStorage.getItem('userid'));


    if (items1) {
      setItemsmachineId(value1);
      setItemsproductID(value2);
      setItemsLinkslotno(value3);
      setItemsLinkOrderId(value4);
      setItemsUserID(items5)
    }
  }, []);
  const paymentgetWay = (e) => {
    e.preventDefault();
 
    

    let body = JSON.stringify({
      machineId:itemsmachineId,
      address_id:"",
      productID:itemsproductID,
      cardNumber:"",
      cardCode:"",
      expirationDate:"",
      id:"",
      slotNo:itemsLinkslotno,
      qty:"1",
      orderno:itemsLinkOrderId,
      userid:itemsLUserID 
     
      
    });
    simplePostCall(ApiConfig.PAYMENT_GETWAY, body)
      .then((res) => {
      console.log(res);
      window.open(res.data);
      
      })

      .catch((err) => {
       
        console.log(err);
      });
  };
  return (
    <>
      <div className="Success">
        <img src={suss} alt="" />
      <div className="BTNS BTNS2">
        <Link to="#"
        
            onClick={(e) => {
              paymentgetWay(e)
            }}
        >Pay Now</Link>
      </div>
      </div>
    </>
  );
};

export default Success;
